import { useRef, useCallback } from "react";

/**
 * Custom hook that provides scroll-to-top functionality
 * @returns {object} An object containing:
 *   - topRef: A ref to attach to an element at the top of the component
 *   - scrollToTop: A function to scroll to the top element smoothly
 */
const useScrollToTop = () => {
  const topRef = useRef<HTMLDivElement>(null);

  const scrollToTop = useCallback(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  return { topRef, scrollToTop };
};

export default useScrollToTop;
